import React from 'react';
import { motion } from 'framer-motion';
import { BeefIcon, DrumstickIcon, FishIcon, LeafIcon, ZapIcon, ClockIcon, ChefHatIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { IMAGES } from '../data/content';
const proteins = [{
  label: 'Carne',
  icon: BeefIcon
}, {
  label: 'Pollo',
  icon: DrumstickIcon
}, {
  label: 'Pescado',
  icon: FishIcon
}, {
  label: 'Cerdo',
  icon: DrumstickIcon
}, {
  label: 'Vegetariano',
  icon: LeafIcon
}];
const levels = [{
  label: 'Simple',
  icon: ZapIcon,
  body: 'Recetas rápidas, con pocos pasos, para los días más ocupados.'
}, {
  label: 'Intermedio',
  icon: ClockIcon,
  body: 'Opciones prácticas para cuando contás con un poco más de tiempo.'
}, {
  label: 'Completa',
  icon: ChefHatIcon,
  body: 'Preparaciones más elaboradas para cuando querés hacer una vianda especial.'
}];
export function ProductBreakdown() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-134" data-mp="1g3nwnv87buuw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-135" data-mp="3j70ta2naiu2w">
        <SectionHeading eyebrow="Qué incluye" title="Recetas organizadas para encontrar una opción en segundos" subtitle="Incluso cuando no sabés qué cocinar, vas directo a la idea justa." data-id="element-136" data-mp="3j44vcebg05eg" />

        <div className="mt-12 grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-137" data-mp="1phmilatcppn">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55
        }} data-id="element-138" data-mp="5rl6xzfgn4n2">
            <h3 className="font-display text-xl font-bold text-green-deep" data-id="element-139" data-mp="fqk86wxwby01">
              Agrupadas por proteína principal
            </h3>
            <div className="mt-4 flex flex-wrap gap-3" data-id="element-140" data-mp="kmj1myy3067b">
              {proteins.map(p => <span key={p.label} className="inline-flex items-center gap-2 rounded-full border border-beige bg-white px-4 py-2 text-sm font-bold text-green-deep shadow-sm" data-id="element-141" data-mp="2hiqc20skzr3o">
                  <p.icon className="h-4 w-4 text-green-brand" data-id="element-142" data-mp="29gfvrx6av87t" />
                  {p.label}
                </span>)}
            </div>

            <h3 className="mt-8 font-display text-xl font-bold text-green-deep" data-id="element-143" data-mp="2of1kdwya2y7b">
              Y divididas por nivel de esfuerzo
            </h3>
            <div className="mt-4 space-y-3" data-id="element-144" data-mp="2xe532ztj9bla">
              {levels.map(l => <div key={l.label} className="flex gap-4 rounded-2xl border border-beige bg-white p-4 shadow-sm" data-id="element-145" data-mp="2xbscxzdmfux5">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-yellow-soft" data-id="element-146" data-mp="373ewcj0450az">
                    <l.icon className="h-6 w-6 text-[#C08A2D]" data-id="element-147" data-mp="325n39lnqf857" />
                  </div>
                  <div data-id="element-148" data-mp="3g55yxezcwr0m">
                    <span className="font-display font-bold text-green-deep" data-id="element-149" data-mp="3g2a2xw72kcet">{l.label}</span>
                    <p className="text-[15px] leading-relaxed text-[#5A6656]" data-id="element-150" data-mp="3c0ybdl4mxh3z">{l.body}</p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.94
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55
        }} className="relative" data-id="element-151" data-mp="3k8y9y63ljuw">
            <img src={IMAGES.lunchbox} alt="Viandas escolares saludables y coloridas preparadas en casa" className="w-full rounded-3xl object-cover shadow-xl" data-id="element-152" data-mp="3bzsospfdwo69" />
            <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 rounded-2xl bg-green-brand px-6 py-3 text-center shadow-lg" data-id="element-153" data-mp="331qibucvt3bl">
              <span className="font-display text-2xl font-black text-white" data-id="element-154" data-mp="36zee0zmef04j">250</span>
              <span className="ml-1 text-sm font-bold text-white/90" data-id="element-155" data-mp="2t42kuwnw5hpq">recetas</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}